import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-student-order-support-article',
    template: `
        <ng-container i18n="@@support.articles.studentOrder">
            <p>If desired, students can also purchase their own license. They enjoy <strong>the same discount rate</strong> as the organization itself.</p>
            <p>In order to benefit from this discounted rate, the student must be linked to the organization. This means that the student was either enrolled by an administrator, or registered via a <strong>class' registration link</strong>.</p>
            <p>
                <a href="/support/organizations/students/enroll" mat-stroked-button color="primary" class="supportLink">Enroll students</a>
            </p>

            <h2>Enrollment by the school</h2>
            <ol>
                <li>
                    <span>Enroll your students</span>
                </li>
                <li>
                    <span>
                        After enrollment you will see the order form. <strong>Close this window without purchasing licenses.</strong>
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/activateLicenses.png" />
                    </span>
                </li>
                <li>
                    <span>
                        When students log in to their account, they can already start with the trial version. A notification will appear at the top of the course to activate their account.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/trialVersion.png" />
                    </span>
                </li>
            </ol>

            <h2>Enrollment by the student (minimum administration)</h2>
            <p>It is possible to have students register themselves, and then have them purchase their own license. This drastically reduces the administrative work for the organization.</p>
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/classes">Classes Overview</a>.</span>
                </li>
                <li>
                    <span>Find the class in the list or use the search field to find the class.</span>
                </li>
                <li>
                    <span>Click the <strong>Add students</strong> button.</span>
                </li>
                <li>
                    <span>
                        Select the <strong>Let students self-enroll</strong> option.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/addStudentsSelfJoin.png" />
                    </span>
                </li>
                <li>
                    <span>Students can register themselves via the <strong>registration link</strong> that you can find here. They are then automatically added to the class.</span>
                </li>
                <li>
                    <span>
                        When students log in to their account, they can already start with the trial version. A notification will appear at the top of the course to activate their account.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/trialVersion.png" />
                    </span>
                </li>
            </ol>
        </ng-container>
    `
})
export class StudentOrderSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
